import StockPositionPresentation from 'components/organisms/presentations/StockPositionPresentation';

const StockPosition = () => <StockPositionPresentation />;

export default StockPosition;
